import React, { memo } from 'react';
import { Text } from '@cuemath/web-comps';
import COLORS from 'constants/colors';

import { STAT_CARDS } from '../../constants';
import { PanelWrapper, StatCard } from './stats-panel-styled';

const StatsPanel = memo(({ stats }) => (
  <PanelWrapper flexDirection="row">
    {STAT_CARDS.map(({ key, label }) => (
      <StatCard key={key}>
        <Text variant="body3" color={COLORS.BLACK_T_60}>
          {label}
        </Text>
        <Text variant="h5">{stats ? (stats[key] ?? 0) : '—'}</Text>
      </StatCard>
    ))}
  </PanelWrapper>
));

StatsPanel.displayName = 'StatsPanel';

export default StatsPanel;
